import { Box, Button, Card, CardContent, Grid, InputLabel, TextField, Typography,MenuItem,Backdrop,CircularProgress } from '@mui/material';
import AdminWrapper from 'csam/admin/components/AdminWrapper';
import { getGraphClient } from 'csam/admin/pages/phishing-emails/getGraphClient';
import React, { useContext, useState, useRef } from 'react';
import 'react-quill/dist/quill.snow.css';
import { useMsal } from '@azure/msal-react';
import EmailInputWithTags from '../phishing-emails/EmailInputWithTags';
import { useAuthenticatedQuery,useAuthenticatedMutation } from 'csam/api/api';
import { fixed, getImage } from 'csam/utils/Constants';
import LocaleContext from 'csam/components/LocaleContext';
import AdminPageLoader from 'csam/admin/components/AdminPageLoader';
import AdminInternalError from '../AdminInternalError';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import ReactQuill, { Quill } from 'react-quill';
import QuillResizeImage from 'quill-resize-image';
import { fixed } from 'csam/utils/Constants';


interface EmailState {
    to: string[];
    excelFile: File | null;
}

interface EmailTemplateData {
  id: number;
  template_title: string;
  email_subject: string;
  email_body: string;
  created_at: string;
  status: number;
}

interface TemplateResponse {
  success: boolean;
  data: EmailTemplateData;
}

const CampaignEmailtemplate = () => {

  const [CampaignTitle, setCampaignTitle] = useState('');
  const { locale } = useContext(LocaleContext);
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);
  const [creatingCampaign, setCreatingCampaign] = useState(false);









  const localeFromStorage = localStorage.getItem('locale') || 'en';
  const { isPending, error, data } = useAuthenticatedQuery<TemplateResponse[]>([locale], {
    url: `${fixed}admin/${locale || localeFromStorage}/email_templates`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

 

  const handleTemplateSelect = (templateId: string) => {
    console.log('template_id',templateId);
    
    setSelectedTemplate(templateId);
  };


  const [email, setEmail] = useState<EmailState>({
    to: [],
    excelFile: null,
});

  





const sendEmailMutation = useAuthenticatedMutation(
  ['send-email-excel', 'POST'],
  (formData: FormData) => ({
    url: `${fixed}email/send-phishing-email`,
    method: 'POST',
    data: formData, // same as your uploadImageMutation
  })
);

const handleSendEmailToBackend = async () => {
  if (!email.to.length) {
    toast.error('No recipients found. Upload an Excel file first.');
    return;
  }

 
  if (!selectedTemplate) {
    toast.error('Please select an email template.');
    return;
  }
 

  // if (!bodyToSend.includes('{{TRACKING_LINK}}')) {
  //   toast.error('The email body must contain {{TRACKING_LINK}} for click tracking.');
  //   return;
  // }
  // Create a new FormData object
  const formData = new FormData();

  // Append additional fields to the formData
//   formData.append('subject', email.subject);
//   formData.append('body', bodyToSend);
  formData.append('templateId', selectedTemplate || '');
  // Handle Excel data - this is where we make sure the file is attached
  const excelFile = email.excelFile;  // This assumes you've set email.excelFile after file upload
  if (excelFile) {
    formData.append('file', excelFile);
  } else {
    toast.error('Please upload an Excel file first!');
    return;
  }

  // If you want to send additional data (like to, cc, bcc etc.)
  
  // Append the JSON stringified excel data (the actual content)
//   formData.append('emails', JSON.stringify(excelData));

  // Now send the request
   try {
      setCreatingCampaign(true);
  const res = await sendEmailMutation.mutateAsync(formData);

  if (res.success) {
  // ✅ closes modal

    toast.success("Campaign created successfully.");



setCampaignTitle("");

setEmail({
    to: [],
    excelFile: null,
});
setSelectedTemplate(null);
  } else {
    toast.error(res.message || 'Failed to send emails.');
  }
} catch (err) {
  toast.error(
    err?.response?.data?.message ||
    "Failed to create campaign."
);
}
finally {

  setCreatingCampaign(false);

}
};


//   const handleUploadExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
//   const file = e.target.files?.[0];
//   if (!file) return;

//   const reader = new FileReader();
//   reader.onload = (event) => {
//     const data = event.target?.result;
//     if (!data) return;

//     const workbook = XLSX.read(data, { type: 'binary' });
//     const firstSheetName = workbook.SheetNames[0];
//     const worksheet = workbook.Sheets[firstSheetName];
//     const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

//     // Map Excel rows to emails
//     const emails = jsonData.map((row) => ({
//       to: row.Email || '', // ensure your column name is Email
//       cc: row.CC ? row.CC.split(/[ ,;]/).map((x) => x.trim()) : [],
//       bcc: row.BCC ? row.BCC.split(/[ ,;]/).map((x) => x.trim()) : [],
//       additionalData: row,
//     }));

//     setEmail((prev) => ({
//       ...prev,
      
      
//       to: emails.map((e) => e.to),
//       cc: emails.flatMap((e) => e.cc),
//       bcc: emails.flatMap((e) => e.bcc),
//       additionalData: emails.map((e) => e.additionalData),
//       excelFile: file,
//     }));
//   };

//   reader.readAsBinaryString(file); // important for XLSX
// };

const handleUploadExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (event) => {
    const data = event.target?.result;
    if (!data) return;

    const workbook = XLSX.read(data, { type: 'binary' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

    // 👇 this is the new version that matches your Excel: to, cc, bcc
    setEmail((prev) => ({
  ...prev,
  to: jsonData.map((row) => row.to || ''),
  excelFile: file,
}));
  };

  reader.readAsBinaryString(file);
};





  if (isPending) return <AdminPageLoader />;
  if (error) return <div>Error: {error.message}</div>;
  if (data && !data.success) return <AdminInternalError />;
  const templates = data.data || [];

 







  return (
    <AdminWrapper>
      <Box className="pageHeader">
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography variant="h6"> Capaign Email </Typography>
        </Box>
      </Box>

      <Box>
        <Box className="form-group" mb={4}>
          <InputLabel>Upload Excel file</InputLabel>
          <TextField type="file" name="file" onChange={handleUploadExcel} fullWidth inputProps={{ accept: '.xlsx,.csv' }}/>
        </Box>


       

       <Box className="form-group" mb={4}>
  <InputLabel>Choose Email Template</InputLabel>

  <TextField
    select
    fullWidth
    value={selectedTemplate || ''}
    onChange={(e) => setSelectedTemplate(e.target.value)}
    size="small"
  >
    <MenuItem value="">
      <em>Select Template</em>
    </MenuItem>

    {templates.map((template) => (
      <MenuItem key={template.id} value={template.id}>
        {template.template_title}
      </MenuItem>
    ))}
  </TextField>
</Box>

        <Button
    variant="contained"
    color="primary"
    onClick={handleSendEmailToBackend}
    disabled={sendEmailMutation.isPending}
>
    {sendEmailMutation.isPending
        ? "Creating Campaign..."
        : "Create Campaign"}
</Button>
      </Box>

      <Backdrop
    open={creatingCampaign}
    sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 999,
        flexDirection: "column",
        gap: 2,
    }}
>
    <CircularProgress color="inherit" />

    <Typography variant="body2">
    Importing {email.to.length} users.

    <br />

    Please do not close or refresh this page.
</Typography>
</Backdrop>
    </AdminWrapper>
  );
};

export default CampaignEmailtemplate;
